import React from "react";
import { Row, Col, Image } from "react-bootstrap";
import about from "../../../assets/Images/About/about.jpg";

const About = () => {
  return (
    <>
      <div className="container " id="About">
        <div className="m-80-0">
          <Row className="align-items-center">
            <Col xl={6} lg={6} md={6}>
              <div className="img-shadow">
              <Image src={about} alt="about" className="img-fluid border-radius" />
              </div>
            </Col>
            <Col xl={6} lg={6} md={6}>
              <p className=" pill d-inline transform-capitalize">thought of the day</p>
              <h2 className="font-cormorant f-50 m-20-0 main-dark-text-color lh-65">
                " The best way you can predict the future is <span className="font-cormorant text-uppercase fw-700 main-dark-text-color"> to create it</span> "
              </h2>
              <p className="main-gray-text f-16 lh-25 m-b-30">
                Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old
              </p>
              <div className="d-flex">
                <div className="about-box border-radius">
                  <h2 className="f-40 ">
                    10
                  </h2>
                  <p className="f-16">
                    Year Experience
                  </p>
                </div>
                <div className="about-box border-radius">
                  <h2 className="f-40 ">
                    420
                  </h2>
                  <p className="f-16">
                    Destination Opthions
                  </p>
                </div>
                <div className="about-box border-radius">
                  <h2 className="f-40 ">
                    36K+
                  </h2>
                  <p className="f-16">
                    Happy Clients
                  </p>
                </div>
              </div>
            </Col>
          </Row>



        </div>
      </div>
    </>
  );
};

export default About; 
